module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Published in 2005 by"), _c('br'), _vm._v("\nGrub Street"), _c('br'), _vm._v("\n4 Rainham Close"), _c('br'), _vm._v("\nLondon"), _c('br'), _vm._v("\nSW11 6SS"), _c('br'), _vm._v("\nEmail: ")]), _c('a', {
    attrs: {
      "href": "mailto:food@grubstreet.co.uk"
    }
  }, [_vm._v("food@grubstreet.co.uk")]), _c('br'), _vm._v("\nWeb: "), _c('a', {
    attrs: {
      "href": "http://www.grubstreet.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.grubstreet.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Text copyright © Marguerite Patten 2005"), _c('br'), _vm._v("\nCopyright this edition © Grub Street 2005"), _c('br'), _vm._v("\nDesign Lizzie Ballantyne")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("The right of Marguerite Patten to be identified as the author of this work has been asserted by her in"), _c('br'), _vm._v("\naccordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Originally published in 1989 as The Complete Book of Teas by Piatkus Books")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing in Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Patten, Marguerite"), _c('br'), _vm._v("\nMarguerite Patten’s 100 top teatime treats"), _c('br'), _vm._v("\n1.Cake 2. Pastry 3. Afternoon teas"), _c('br'), _vm._v("\nI. Title II 100 top teatime treats"), _c('br'), _vm._v("\n641.8’65")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN-10 : 1 904943 29 2"), _c('br'), _vm._v("\nPRINT ISBN: 978 1 904943 29 7"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 909808 70 6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means,"), _c('br'), _vm._v("\nelectronic or mechanical, including photocopying, recording or any information storage and retrieval"), _c('br'), _vm._v("\nsystem, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Printed and bound in Spain")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa865f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0